import { GetCharacteristicsQuery, VehicleModel } from "@/generated/graphql";

type VehicleData = {
  batteryVoltage?: string;
  batteryTemperature?: string;
  cycleCount?: string;
  estimatedDistance?: string;
  estimatedDailyDistance?: string;
  stateOfCharge?: number;
  stateOfHealth?: number;
};

const oldModels = [
  VehicleModel.TukTuk_5Seats,
  VehicleModel.W2500GreyVintage,
  VehicleModel.W2500Red,
];

export const getVehicleData = (
  model: VehicleModel,
  characteristics: GetCharacteristicsQuery,
): VehicleData => {
  const vehicleCharacteristics =
    characteristics?.currentEndUser?.characteristics.vehicleCharacteristics;

  let vehicleData: VehicleData = {
    estimatedDistance:
      vehicleCharacteristics?.estimatedDistance.last?.data.toFixed(1),
    estimatedDailyDistance:
      vehicleCharacteristics?.estimatedDailyDistance.last?.data.toFixed(1),
  };

  if (oldModels.includes(model)) {
    const batteryData = vehicleCharacteristics?.bmsOutputVoltage.last?.data;
    vehicleData.batteryVoltage = batteryData
      ? (batteryData / 100).toFixed(2)
      : undefined;

    vehicleData.cycleCount =
      vehicleCharacteristics?.bmsCapacity.last?.cycleCount.toString();
    vehicleData.batteryTemperature =
      vehicleCharacteristics?.bmsMaxTemperature.last?.data.toString();

    const current = vehicleCharacteristics.bmsCapacity.last;

    if (vehicleCharacteristics && current) {
      vehicleData.stateOfCharge =
        (current.remainingCapacity / current.fullCapacity) * 100;
    }

    vehicleData.stateOfHealth = 100; // Old models do not have SOH data so we default to 100%
  } else {
    vehicleData.batteryVoltage =
      vehicleCharacteristics.batteryStatus.last?.totalVoltage.toFixed(2);
    vehicleData.stateOfCharge = vehicleCharacteristics.batteryStatus.last?.soc;
    vehicleData.cycleCount =
      vehicleCharacteristics.batteryCapacity.last?.cycleCount.toString();
    vehicleData.batteryTemperature =
      vehicleCharacteristics.cellTemperatureInfo.last?.average.toFixed(1);
    vehicleData.stateOfHealth = vehicleCharacteristics.batteryStatus.last?.soh;
  }

  return vehicleData;
};
